import { loginActions } from "./login.actions";
import { budgetCategoryActions } from "./budgetCategory.actions";
import { userActions } from "./user.actions";
import { passwordActions } from "./password.actions";
import { userPendingApprovalsActions } from "./userPendingApprovals.actions";
import { pricePlanPendingApprovalsActions } from "./pricePlanPendingApprovals.actions";
import { pricePlanActions } from "./pricePlan.actions";
import { availableDocumentActions } from "./availableDocument.action";
import { fiActions } from "./fi.actions";
import { appConfigActions } from "./app.config.action";
import { billerProfileActions } from "./billerProfile.action";
import { billerPendingApprovalsActions } from "./billerPendingApprovals.actions";
import { viewStatisticsActions } from "./viewStatistics.actions";
import { transactionEnquiryActions } from "./transactionEnquiry.actions";
import { traceManagementActions } from "./traceManagement.actions";
import { recallPaymentCustomerActions } from "./recallPaymentCustomer.actions";
import { batchHolidayActions } from "./batchHoliday.action";
import { synchronizationActions } from "./synchronization.action";
import { faxManagementActions } from "./faxManagement.actions";
import { tracePaymentActions } from "./tracePayment.action";
import { serviceLevelMonitoringActions } from "./serviceLevelMonitoring.actions";
import { billerCrossReferenceActions} from "./billerCrossReference.actions";
import { pendingBcrActions } from "./pendingBcr.actions";

const actions = {
  loginActions,
  budgetCategoryActions,
  batchHolidayActions,
  userActions,
  passwordActions,
  userPendingApprovalsActions,
  pricePlanActions,
  availableDocumentActions,
  pricePlanPendingApprovalsActions,
  fiActions,
  appConfigActions,
  billerProfileActions,
  billerPendingApprovalsActions,
  transactionEnquiryActions,
  traceManagementActions,
  recallPaymentCustomerActions,
  viewStatisticsActions,
  synchronizationActions,
  faxManagementActions,
  tracePaymentActions,
  serviceLevelMonitoringActions,
  billerCrossReferenceActions,
  pendingBcrActions,
};

export default actions;
